type EvidenceCandidate = {
  correctedByHuman?: boolean;
  value?: unknown;
  page?: number;
  sourceDocumentPage?: number;
  provenance?: string;
  sourceProvenance?: string;
  facts?: Array<{
    label: string;
    value: string | number;
    unit?: string;
    period?: string;
    page?: number;
    provenance?: string;
    sourceText?: string;
  }>;
  normalized?: Array<{ source?: { page?: number; provenance?: string } }>;
};

/** Entry sources override the historical aggregate's last-page marker. */
export function billCandidateSource(candidate: EvidenceCandidate): string {
  const entries = candidate.facts?.length
    ? candidate.facts
    : (candidate.normalized?.map(r => r.source ?? {}) ?? []);
  const pages = [
    ...new Set(
      entries
        .map(entry => entry.page)
        .filter((p): p is number => Number.isInteger(p) && Number(p) > 0)
    ),
  ].sort((a, b) => a - b);
  if (!pages.length && (candidate.sourceDocumentPage ?? candidate.page))
    pages.push((candidate.sourceDocumentPage ?? candidate.page)!);
  const sources = new Set(
    entries.map(entry => entry.provenance).filter(Boolean)
  );
  const partial = entries.some(entry => !entry.provenance);
  const rawSourceLabel = entries.length
    ? sources.size > 1
      ? `fuentes mixtas${partial ? " · procedencia parcial" : ""}`
      : partial
        ? sources.size
          ? "procedencia parcial"
          : "procedencia no indicada"
        : [...sources][0]
    : (candidate.sourceProvenance ?? candidate.provenance ?? "documento");
  const sourceLabel = rawSourceLabel === "not_found_in_document" ? "No encontrado en la factura" : rawSourceLabel;
  return `${sourceLabel}${pages.length ? ` · ${pages.length > 1 ? "págs." : "pág."} ${pages.join(", ")}` : entries.length || rawSourceLabel === "documento" ? " · página no indicada" : ""}`;
}

export function BillCandidateEvidence({
  candidate,
}: {
  candidate: EvidenceCandidate;
}) {
  if (!candidate.facts?.length)
    return (
      <div className="break-words whitespace-pre-wrap">
        {Array.isArray(candidate.value)
          ? candidate.value.join(" · ")
          : String(candidate.value ?? "")}
      </div>
    );
  return (
    <div className="min-w-0">
      {candidate.correctedByHuman && (
        <div className="break-words whitespace-pre-wrap">
          Dato corregido:{" "}
          {Array.isArray(candidate.value)
            ? candidate.value.join(" · ")
            : String(candidate.value ?? "")}
        </div>
      )}
      <details className="min-w-0">
        <summary className="cursor-pointer">
          {candidate.facts.length} datos del original con fuente · revisar
          individualmente
        </summary>
        <ul
          className="mt-2 max-h-64 space-y-2 overflow-y-auto break-words"
          aria-label="Datos y páginas de origen"
        >
          {candidate.facts.map((fact, index) => (
            <li key={index}>
              <span className="font-medium">
                {fact.label}: {fact.value}
                {fact.unit ? ` ${fact.unit}` : ""}
                {fact.period ? ` · ${fact.period}` : ""}
              </span>
              <span className="text-muted-foreground">
                {" "}
                · {fact.provenance ?? "documento"} ·{" "}
                {fact.page ? `pág. ${fact.page}` : "página no indicada"} ·
                requiere revisión
              </span>
              {fact.sourceText && (
                <div className="whitespace-pre-wrap text-muted-foreground">
                  Fuente: {fact.sourceText}
                </div>
              )}
            </li>
          ))}
        </ul>
      </details>
    </div>
  );
}
